import React from 'react'

import MfaChallenge from '../mfa-challenge/A4_index'

function OAuthMfaChallenge() {
  return <MfaChallenge isOAuth={true} />
}

export default OAuthMfaChallenge
